module.exports = "//public.getcloudapp.com/packs/media/images/icons-mouse-click-gray-08f83c46cb570df067a4a60df255f987.svg";